import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export type MetaCarouselCardFormat = 'Image' | 'Video';

export interface MetaCarouselCardModel extends BaseModel {
  variables?: { [key: string]: string } | MetaCarouselCardVariables;
}

/**
 * One card of the carousel.
 * `Format` is 'Image' or 'Video' and says which upload control fills `Media` (the uploaded image or video URL).
 */
export interface MetaCarouselCardVariables {
  Headline: string;
  Link: string;
  Format: string;
  Media: string;
}

export class MetaCarouselCardInitVariables implements MetaCarouselCardVariables {
  Headline = '';
  Link = '';
  Format = 'Image';
  Media = '';
}

export class MetaCarouselCardInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaCarouselCardInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
